import loadIconAsset from '../helpers/loadIconAsset';
import useAsset from './useAsset';

export default function useIconAsset(iconName: string) {
    return useAsset(loadIconAsset, iconName);
}
